import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Student Section Imports
import StudentLogin from "./sections/studentPortal/pages/StudentLogin";
import StudentRegistration from "./sections/studentPortal/pages/StudentRegistration";
import Leaderboard from "./sections/studentPortal/pages/Leaderboard";
import CoursePlayer from "./sections/studentPortal/pages/CoursePlayer";
import Quiz from "./sections/studentPortal/pages/Quiz";
// Admin Section imports
import AdminLogin from "./sections/adminPortal/pages/AdminLogin";
import Dashboard from "./sections/adminPortal/pages/Dashboard";
import Assignment from "./sections/adminPortal/pages/Assignment";
import AssignmentMark from "./sections/adminPortal/pages/AssignmentMark";
import Quizzes from "./sections/adminPortal/pages/Quizzes";
import Videos from "./sections/adminPortal/pages/Videos";
import AddVideo from "./sections/adminPortal/components/AddVideo";
// Custom hooks for student and admin authentication checking
import useAdminAuthCheck from "./sections/adminPortal/hooks/useAdminAuthCheck";
import useStudentAuthCheck from "./sections/studentPortal/hooks/useStudentAuthCheck";
import AddAssignment from "./sections/adminPortal/components/AddAssignment";
import AddQuiz from "./sections/adminPortal/components/AddQuiz";
import EditVideo from "./sections/adminPortal/components/EditVideo";
import EditAssignment from "./sections/adminPortal/components/EditAssignment";
import EditQuiz from "./sections/adminPortal/components/EditQuiz";
import PublicRoute from "./sections/PublicRoute";
import PrivateRoute from "./sections/PrivateRoute";

function App() {
  const studentAuthCheck = useStudentAuthCheck();

  const adminAuthCheck = useAdminAuthCheck();

  console.log(studentAuthCheck, adminAuthCheck);

  return !studentAuthCheck && !adminAuthCheck ? (
    <Router>
      <Routes>
        // Student Routes
        <Route
          exact
          path="/"
          element={
            <PublicRoute>
              <StudentLogin />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <StudentRegistration />
            </PublicRoute>
          }
        />
        // Admin Routes
        <Route
          path="/admin"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />
      </Routes>
    </Router>
  ) : studentAuthCheck && !adminAuthCheck ? (
    <Router>
      <Routes>
        <Route
          path="/leaderboard"
          element={
            <PrivateRoute>
              <Leaderboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/course-player"
          element={
            <PrivateRoute>
              <CoursePlayer />
            </PrivateRoute>
          }
        />
        <Route
          path="/course-player/:vId"
          element={
            <PrivateRoute>
              <CoursePlayer />
            </PrivateRoute>
          }
        />
        <Route
          path="/quiz"
          element={
            <PrivateRoute>
              <Quiz />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  ) : adminAuthCheck && !studentAuthCheck ? (
    <Router>
      <Routes>
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        // Assignment related Routes for admin
        <Route
          path="/admin/assignment"
          element={
            <PrivateRoute>
              <Assignment />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/assignment/:assId"
          element={
            <PrivateRoute>
              <EditAssignment />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/assignment/add-assignment"
          element={
            <PrivateRoute>
              <AddAssignment />
            </PrivateRoute>
          }
        />
        // AssignmentMark related Routes for Admin
        <Route
          path="/admin/assignment-mark"
          element={
            <PrivateRoute>
              <AssignmentMark />
            </PrivateRoute>
          }
        />
        // Quiz related Routes for admin
        <Route
          path="/admin/quizzes"
          element={
            <PrivateRoute>
              <Quizzes />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/quizzes/:qId"
          element={
            <PrivateRoute>
              <EditQuiz />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/quizzes/add-quiz"
          element={
            <PrivateRoute>
              <AddQuiz />
            </PrivateRoute>
          }
        />
        // Videos related Routes for admin
        <Route
          path="/admin/videos"
          element={
            <PrivateRoute>
              <Videos />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/videos/:vId"
          element={
            <PrivateRoute>
              <EditVideo />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/videos/addVideo"
          element={
            <PrivateRoute>
              <AddVideo />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  ) : (
    <div>Checking Authentication..</div>
  );
}

export default App;
